export const TodayViewLayoutName = {
    LINEAR: 'linear',
    LIST: 'list',
};
